import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { RemarksComponent } from 'src/app/admin/menus/events/remarks/remarks.component';
import { EmailModalComponent } from '../email-modal/email-modal/email-modal.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-coe-list',
  templateUrl: './coe-list.component.html',
  styleUrls: ['./coe-list.component.css'],
})
export class CoeListComponent implements OnInit {
  @ViewChild('input') inputElement: ElementRef<HTMLInputElement>;
  displayedColumns: string[] = [
    'index',
    'incubatorName',
    'applicationNumber',
    'profileRegistered',
    'time',
    'reason',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.CoeList;
  formValue: FormGroup;
  /**
   * Class constructor.
   * Initializes the component by setting up the form and table data source.
   * @param router The angular router service.
   * @param fb The angular form builder service.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {
    /**
     * Initialize the MatTableDataSource with empty data.
     */
    this.dataSource = new MatTableDataSource();
    /**
     * Create the form group with the required fields.
     */
    this.formValue = this.fb.group({
      type: ['0'], // Default value set to '0' for "Pending"
    });
  }

  roleValue;
  searchVal;
  coeStatus;
  /**
   * Lifecycle hook that is called after data-bound properties of a directive are initialized.
   * Initializes visibility, retrieves role and status from session storage, and sets up the form and list.
   */
  ngOnInit(): void {
    // Set the visibility source to true
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Remove the applicationId from session storage
    sessionStorage.removeItem('applicationId');

    // Assign the search value to searchVal
    this.searchVal = this.searchValue;

    // Get the CoE status from session storage
    this.coeStatus = sessionStorage.getItem('coeStatus');

    // If a CoE status is present, set it in the form
    if (this.coeStatus != null) {
      this.formValue.get('type')?.setValue(this.coeStatus);
    }

    // Fetch the CoE list
    this.coeList();
  }
  // Search code
  searchValue: string;
  /**
   * Applies search filtering based on the user's input.
   * Resets pagination and updates the list with the search string
   * and status if the input length conditions are met.
   * @param event - The input event containing the search value.
   */
  applySearch(event: Event) {
    // Extract the filter value from the input event
    const filterValue = (event.target as HTMLInputElement).value;
    // Update the search value with the filter value
    this.searchValue = filterValue;

    // Reset pagination if paginator is defined
    if (this.paginator != undefined) {
      this.paginator.pageIndex = 0;
      this.pageNumber = 1;
    }

    // Check if the search value length is greater than 3 or equal to 0
    if (this.searchValue.length > 3 || this.searchValue.length == 0) {
      // Update the list object with the current search, pagination, and status
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        searchString: this.searchValue,
        status: this.coeStatus ? this.coeStatus : '0',
      };
      // Call the API to fetch the filtered list
      this.ListApi();
    }
  }

  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of CoEs from the API based on the pagination.
   * Subscribes to the API response and updates the component's data fields
   * based on the response.
   * @returns An observable containing the response from the API.
   */
  coeList() {
    // Set the list object with the current search value, page number, and status
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      incubatorName: this.searchValue,
      status: this.coeStatus ? this.coeStatus : '0',
    };

    // Call the ListApi function to fetch the list of CoEs
    this.ListApi();
  }
  req;
  excelval;
  /**
   * Fetches the list of incubators from the API using the current search
   * parameters and pagination.
   * Subscribes to the API response and updates the component's data fields
   * based on the response.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    // Show the loader while fetching data
    this.getdata.amizhthLoader('show');

    // Clear the list of incubators
    this.disList = [];

    // Call the API to fetch the list of incubators
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        // Hide the loader after receiving data
        this.getdata.amizhthLoader('hide');

        // Check if the response contains any data
        if (data.count == 0) {
          // If there is no data, show the "No Data" message
          this.noData = true;
        } else {
          // If there is data, update the component data
          this.noData = false;
          // Update the page total count
          this.pageTotalCount = data.count;
          // Update the list of incubators
          this.disList = data.coe;
          // Set the MatTableDataSource with the list of incubators
          this.dataSource = new MatTableDataSource(data.coe);
        }
      });
  }
  sam;
  /**
   * Saves the incubator name and id to the session storage and navigates to the coe dashboard.
   * @param id The id of the incubator.
   * @param name The name of the incubator.
   */
  incubaName(id, name) {
    // Save the incubator name and id to the session storage.
    sessionStorage.setItem('userId', id);
    sessionStorage.setItem('adminIncubName', name);
    // Save the adminPreIncubVal to the session storage.
    sessionStorage.setItem('adminPreIncubVal', '1');

    // Get the adminPreIncubVal from the session storage.
    this.sam = sessionStorage.getItem('adminPreIncubVal');

    // If the adminPreIncubVal is 1, navigate to the coe dashboard.
    if (this.sam == '1') {
      this.router.navigateByUrl('/admin/coe/dashboard');
    }
  }
  /**
   * Initializes the paginator after the component view has been initialized.
   * Called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Handles the pagination event.
   * Resets the input field, updates the page number and page size,
   * and calls the ListApi function to fetch the updated data.
   * @param event The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Reset the input field
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      status: parseInt(this.selectedOption),
    };
    // Call the API to fetch the updated data
    this.ListApi();
  }
  selectedOption = '0';
  /**
   * Handles the selection change event for the status option.
   * Updates the search value, resets input fields, and updates the session storage.
   * Resets pagination and triggers the list API to fetch data based on the selected status.
   * @param option The selected status option.
   */
  onSelect(option) {
    // Clear the search value
    this.searchVal = '';

    // Reset the input element's value if it exists
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }

    // Update the selected option and store it in session storage
    this.selectedOption = option;
    this.coeStatus = this.selectedOption;
    sessionStorage.setItem('coeStatus', this.selectedOption);

    // Reset pagination if the paginator is defined
    if (this.paginator != undefined) {
      this.paginator.pageIndex = 0;
      this.pageNumber = 1;
    }

    // Update the list object with the new status and pagination details
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      status: this.selectedOption,
    };

    // Call the API to fetch the updated list based on the selected status
    this.ListApi();
  }
  /**
   * Opens a dialog box for viewing the description of the selected application.
   * @param status The status of the application.
   * @param title The title of the application.
   * @param applicationId The ID of the application.
   */
  viewDescrptionBtn(status: string, title: string, applicationId: string) {
    let dialogWidth = '390px'; // default for desktop

    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        if (result.matches) {
          dialogWidth = '90vw'; // 90% of the screen width on mobile
        }

        const dialogRef = this.dialog.open(RemarksComponent, {
          width: dialogWidth,
          maxWidth: '95vw',
          data: {
            _status: status,
            _title: title,
            _applicationId: applicationId,
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          // handle result
        });
      });
  }
  /**
   * Opens a modal dialog box for sending an email to the selected application.
   * The modal dialog box takes the list of applications as input.
   */
  openModal() {
    // Check if the search value is undefined and set it to an empty string if it is
    if (this.searchValue == undefined) {
      this.searchValue = '';
    }

    // Set the name of the status based on the selected option
    let name;
    switch (this.selectedOption) {
      case '0':
        this.excelval = 0;
        name = 'Pending';
        break;
      case '1':
        this.excelval = 1;
        name = 'Submitted';
        break;
      case '2':
        this.excelval = 2;
        name = 'Under Process Verficiation';
        break;
      case '3':
        this.excelval = 3;
        name = 'Under Clarification';
        break;
      case '4':
        this.excelval = 4;
        name = 'Approved';
        break;
      case '5':
        this.excelval = 5;
        name = 'Rejected';
        break;
    }

    // Open the modal dialog box
    const dialogRef = this.dialog.open(EmailModalComponent, {
      width: '700px',
      height: '300px',
      data: { _key: this.list },
    });

    // Subscribe to the afterClosed event and do nothing with the result
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
